import { Component, input, output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { FormInputComponent, FormNumberComponent } from '@shared/forms';
import { TierFormGroup } from '../../types';

@Component({
    selector: 'app-tier-row',
    templateUrl: './tier-row.component.html',
    styleUrls: ['./tier-row.component.scss'],
    imports: [ReactiveFormsModule, TranslateModule, FormInputComponent, FormNumberComponent, Button],
})
export class TierRowComponent {
    readonly group = input.required<TierFormGroup>();
    readonly index = input.required<number>();

    readonly remove = output<void>();
}
